import { all, fork, takeEvery, call, put } from 'redux-saga/effects';
import app from '../../app';
import { loadHappygoProductMasterCompletion } from '../../actions';

function* watchLoadProductList() {
  yield takeEvery('LOAD_HAPPYGO_PRODUCT_MASTER', function*() {
    const options = {
      url: '/efapi/product/list',
    };
    const result = yield call(app.httpFetch, options);

    yield put(
      loadHappygoProductMasterCompletion(result.error, result.data || [])
    );
  });
}

export default function* productSaga() {
  yield all([fork(watchLoadProductList)]);
}
